import styled from 'styled-components';

export const TotalsInfoCardContainer = styled.div`
  width: 390px;
  min-width: 28%;
  max-width: 536px;
  height: 144px;
  max-height: 144px;

  display: flex;
  flex-direction: column;
  position: relative;

  flex: 1;

  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 16px;

  padding: 16px 16px 8px 16px;
  margin-top: 24px;

  > span {
    position: absolute;
    top: -16px;
    left: 16px;
    border-radius: 8px;
    width: 56px;
    height: 56px;
    background-color: ${({ theme }) => theme.colors.orange.primary};

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 32px;
      height: 32px;
      color: ${({ theme }) => theme.colors.white};
    }
  }

  > div {
    width: 100%;
    height: 98%;

    display: flex;
    flex-direction: column;
    align-items: end;

    border-bottom: ${({ theme }) => theme.colors.gray[400]} 1px solid;

    p {
      font-weight: 500;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.gray[600]};
    }
    h1 {
      font-weight: 800;
      font-size: 30px;
      margin: 8px 0px;
      color: ${({ theme }) => theme.colors.gray[900]};
    }
  }

  > footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    min-height: 24px;

    p {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray[600]};
    }
    strong {
      color: ${({ theme }) => theme.colors.orange.primary};
    }
  }
`;
